import { render, staticRenderFns } from "./dialogMenuItem.vue?vue&type=template&id=62b62e98&"
import script from "./dialogMenuItem.vue?vue&type=script&lang=js&"
export * from "./dialogMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports